// src/utils/messageFormatter.js
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});

function escapeHtml(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export default function formatAssistantMessage(text, format = 'text') {
  if (!text) return '';

  let html = '';

  switch ((format || 'text').toLowerCase()) {
    case 'html':
      html = text;
      break;
    case 'markdown':
      html = md.render(text);
      break;
    case 'text':
    default:
      html = escapeHtml(text).replace(/\n/g, '<br>');
      break;
  }

  return DOMPurify.sanitize(html);
}
